angular.module('dentalLinks')
.controller('NotesController', ['$scope', 'Auth', '$uibModal', 'Logger', 'ModalHandler', 'Note', 'Notification', 'Activity', 'FeatureConfig',
    function ($scope, Auth, $uibModal, Logger, ModalHandler, Note, Notification, Activity, FeatureConfig) {
        $scope.auth = Auth.get();
        
        FeatureConfig.findByName({name: 'notes.generate.enabled'}).$promise
            .then(function (response) {
                console.log('FeatureConfig', JSON.stringify(response, null, 2));

                $scope.allowGenerateNotes = (response.value == 'true');
            });

        // TODO: what does this do? And in what case?
        if($scope.referral.$promise) {
            $scope.referral.$promise.then(function() {
                console.log('referral promise resolved');

                Activity.patientsChanges({patient_id: $scope.referral.patient_id, start_date: $scope.referral.created_at},
                    function(data) {
                        console.log('Activity.patientsChanges:\n', JSON.stringify(data.activities, null, 2));
                        $scope.referral.notes = $scope.referral.notes.concat(data.activities);
                    });
            });
        }

        $scope.noteDialog = function () {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/note_form.html',
                controller: 'NoteModalController',
                resolve: {
                    referral: function() {
                        const referral = $scope.referral;
                        console.log('resolve: referral.id', referral.id);
                        return referral;
                    },
                    allowGenerate: function() {
                        // need Generate functionality when responding to an existing referral, concides with the immediateUpdate
                        return $scope.immediateUpdate && $scope.allowGenerateNotes;
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (message) {
                if ($scope.showOfferToInviteGuest) {
                    $scope.showOfferToInviteGuest();
                }
                if ($scope.immediateUpdate) {
                    Note.save({note: {message: message, referral_id: $scope.referral.id, user_id: $scope.auth.id}}, function (success) {
                        $scope.referral.notes.push(success);
                    }, function (failure) {
                        Notification.error('Something went wrong, note was not saved.');
                    });
                } else {
                    if(typeof $scope.$parent.form !== 'undefined' && $scope.$parent.form !== null) {
                        $scope.$parent.form.$setDirty(); // for UnsavedChanges to notice notes being changed
                    }
                    var note = {
                        message: message,
                        created_at: Date.now(),
                        user_id: $scope.auth ? $scope.auth.id : '',
                        user: {
                            first_name: Auth.current_user ? Auth.current_user.first_name : '',
                            last_name: Auth.current_user ? Auth.current_user.last_name : ''
                        }
                    };
                    $scope.referral.notes = $scope.referral.notes || [];
                    $scope.referral.notes_attributes = $scope.referral.notes_attributes || [];
                    $scope.referral.notes.push(note);
                    $scope.referral.notes_attributes.push(note);
                }
            }).catch(function () {
                Logger.log('Modal dismissed');
            });
        };

        $scope.showHistory = function(note){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/note_versions.html',
                controller: 'NoteVersionsModalController',
                size: 'lg',
                resolve: {
                    versions : function(){
                        return note.versions;
                    }
                }
            });
        };
        
        $scope.hasUpdates = function (note) {
            return note.versions && note.versions.some(function (version) {
                return version.event === 'update'
            });
        };

        $scope.editNote = function(note, index){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/edit_note_form.html',
                controller: 'EditNoteModalController',
                resolve: {
                    noteData : function(){
                        return note;
                    }
                }
            });
            modalInstance.result.then(function (note) {
                if($scope.showOfferToInviteGuest) {
                    $scope.showOfferToInviteGuest();
                }
                if($scope.immediateUpdate){
                    Note.update({id: note.id}, {note: note}, function(success){
                        $scope.referral.notes[index] = success;
                    }, function(failure){
                        Notification.error('Something went wrong, note was not updated.');
                    });
                } else {
                    if(typeof $scope.$parent.form !== 'undefined' && $scope.$parent.form !== null) {
                        $scope.$parent.form.$setDirty();
                    }
                    $scope.referral.notes[index] = note;
                    $scope.referral.notes_attributes[index] = note;
                }
            }).catch(function () {
                Logger.log('Modal dismissed');
            });
        };
    }]);
